import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Collection from 'assets/components/data/Collection';
import Row from 'assets/components/data/rows/Row';
import RowActions from 'assets/components/data/rows/RowActions';
import RowData from 'assets/components/data/rows/RowData';
import RowImage from 'assets/components/data/rows/RowImage';
import ThemeCollectionTable from 'assets/components/data/themes/Theme.Collection.Table';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import { getLocales } from 'assets/locales/Locale';
import HeaderRow from 'assets/components/data/rows/HeaderRow';
import HeaderData from 'assets/components/data/rows/HeaderData';
import DealerGroup from 'models/dealerManagement/dealerGroup/Model.DealerGroup';
import { useProductEnhancementDealerGroupDocumentProvider } from '../ProductEnhancementDocument.DealerGroupDocuments.Hooks';

export default function DealerGroupDocumentList() {
  const { lang } = getLocales();
  const { dealerGroupDocumentList, selectedItems, toggleItem } = useProductEnhancementDealerGroupDocumentProvider();

  return dealerGroupDocumentList.count == 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.documents}
      render={lang.noInfo}
    />
  ) : (
    <Collection class={ThemeCollectionTable}>
      <HeaderRow>
        <HeaderData>{lang.dealerGroup}</HeaderData>
        <HeaderData>{lang.document}</HeaderData>
        <HeaderData numOfActions={1} />
      </HeaderRow>
      <DataMap
        data={dealerGroupDocumentList.data?.map((x) => ({ ...x, dealerGroup: new DealerGroup(x.dealerGroup) }))}
        render={({ data: productDealerGroupDocument }) => {
          const isDocumentSelected = selectedItems?.find(
            (it) => it.dealerGroupId === productDealerGroupDocument.dealerGroupId
          );

          return (
            <Row
              key={productDealerGroupDocument.dealerGroupId}
              children={
                <>
                  <RowImage render={<Icon class="fas-users" />} />
                  <RowData {...productDealerGroupDocument.dealerGroup.displayInfo} />
                  <RowData>{productDealerGroupDocument.mediaFile?.name ?? '-'}</RowData>
                  <RowActions isVertical>
                    <Button
                      data={productDealerGroupDocument}
                      onClick={toggleItem}
                      class={ThemeButtonCircle}
                      media={<Icon class={isDocumentSelected ? 'fas-check-square' : 'far-square'} />}
                      htmlElementProps={{ title: isDocumentSelected ? lang.unselect : lang.select }}
                    />
                  </RowActions>
                </>
              }
            />
          );
        }}
      />
    </Collection>
  );
}
